"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavSidebar = void 0;
const ui_1 = require("@app/component/ui");
const modal_sidebar_button_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-button");
const modal_sidebar_container_1 = require("@app/component/ui/modal/modal-sidebar/modal-sidebar-container");
const util_1 = require("@app/util");
const is_admin_1 = require("@app/util/hooks/is-admin");
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const unavailability_context_1 = require("../unavailability-context");
const use_available_unav_sections_1 = require("../util/use-available-unav-sections");
const isSectionChecked = (arr, sec) => arr.includes(sec);
const SidebarItem = ({ section, onChange }) => {
    const { toggleSection, toggledSections } = (0, unavailability_context_1.useUnavailability)();
    const { label, name, id } = section;
    return (react_1.default.createElement("div", { style: { display: 'flex', gap: '0.5rem', marginBottom: '0.5rem' } },
        react_1.default.createElement(ui_1.Checkbox, { testid: `section-${section.id}`, disabled: section.isBlocked || section.isDisabled, onDisabledClick: section.isBlocked
                ? () => react_hot_toast_1.default.custom(() => (react_1.default.createElement(ui_1.Alert, { style: { height: 'fit-content' }, type: 'WARNING' },
                    react_1.default.createElement(ui_1.Text, null, (0, util_1.t)('WARN_MESSAGE.functionBlockedByPlugin')),
                    (0, util_1.isValue)(section.blockedAlertContextExtra) &&
                        section.blockedAlertContextExtra)))
                : undefined, checked: isSectionChecked(toggledSections, id), onChange: (v) => {
                toggleSection(id, v);
                onChange?.(v);
            } },
            react_1.default.createElement(ui_1.Text, { type: 'body-large' }, label ?? name))));
};
const UnavSidebar = () => {
    const { selectedTab, setSelectedTab } = (0, unavailability_context_1.useUnavailability)();
    const isAdmin = (0, is_admin_1.useIsAdmin)();
    const _sections = (0, use_available_unav_sections_1.useAvailableUnavSections)();
    const sections = _sections.filter((sec) => !(0, util_1.isValue)(sec.visible) || sec.visible);
    const groups = (0, use_available_unav_sections_1.splitSectionsByGroup)(sections);
    return (react_1.default.createElement(modal_sidebar_container_1.ModalSidebarContainer, null,
        react_1.default.createElement("div", { style: { flex: 0, height: 'max-content', marginBottom: '0.5rem' } },
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'overview', onClick: () => setSelectedTab('overview'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, (0, util_1.t)('DASHBOARD'))),
        react_1.default.createElement("div", { 
            // ref={sidebarScrollRef}
            style: {
                flexBasis: '100%',
                flex: 1,
                height: '100%',
                width: '100%',
                overflowY: 'auto',
                paddingLeft: '0.5rem',
                // boxShadow: isScrollable
                //   ? 'inset 0 -10px 10px -10px rgb(0 0 0 / 10%)'
                //   : undefined,
            } }, selectedTab === 'overview' &&
            groups.map((group) => (react_1.default.createElement(react_1.default.Fragment, { key: group.key },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(ui_1.Text, { type: 'body-large', weight: 'bold', style: {
                            marginBottom: '0.75rem',
                        } }, group.key),
                    react_1.default.createElement(SidebarItem, { section: group.data[0] })),
                group.data
                    .slice(1)
                    .filter((s) => (0, util_1.isUndefined)(s.visible) || s.visible)
                    .map((section) => (react_1.default.createElement(SidebarItem, { key: section.id, section: section }))))))),
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
                flex: 0,
                height: 'max-content',
            } },
            isAdmin && (react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'dev-view', onClick: () => setSelectedTab('dev-view'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, "Dev tools")),
            react_1.default.createElement(modal_sidebar_button_1.ModalSidebarButton, { ico: 'template', selected: selectedTab === 'statistics', onClick: () => setSelectedTab('statistics'), style: { alignItems: 'center', gap: '0.5rem', flexShrink: 0 } }, (0, util_1.t)('SHIFT_STATS_TITLE')))));
};
exports.UnavSidebar = UnavSidebar;
